import Modal from 'trunks/vue/admin/components/modals/modal.js'

const MAX_RECIPIENTS = 20
const DEFAULT_AVATAR = '/non-digested-assets/avatars/default_96.png'

export default Vue.extend({
  components: {
    modal: Modal
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    typeTitle: {
      type: String,
      default: ''
    },
    wechatTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keyword: '',
      users: [],
      searching: false,
      pushing: false,
      error: '',
      result: null,
      selectedIds: [],
      maxRecipients: MAX_RECIPIENTS,
      defaultAvatar: DEFAULT_AVATAR
    }
  },
  computed: {
    selectedCount() {
      return this.selectedIds.length
    },
    contextTitle() {
      if (this.typeTitle && this.wechatTitle) return `${this.typeTitle} · ${this.wechatTitle}`
      return this.typeTitle || this.wechatTitle || this.template.title
    },
    sendLabel() {
      if (this.pushing) return '推送中…'
      return `发送测试（${this.selectedCount}）`
    },
    emptyHint() {
      if (this.searching) return '搜索中…'
      if (this.keyword) return '没有匹配的已绑定用户'
      return '没有已绑定微信的用户'
    }
  },
  created() {
    this.scheduleSearch = _.debounce(this.searchUsers, 300)
    this.searchUsers()
  },
  mounted() {
    document.body.appendChild(this.$el)
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  methods: {
    searchUsers() {
      this.searching = true
      this.error = ''
      Skylark.Libs.Ajax.get('/admin/settings/wechat_push_templates/binded_users.json', {
        data: { keyword: this.keyword },
        responseType: 'json',
        success: (data) => {
          this.users = data
        },
        error: (xhr) => {
          this.error = this.errorMessage(xhr, '搜索用户失败')
        },
        complete: () => {
          this.searching = false
        }
      })
    },
    isSelected(userId) {
      return this.selectedIds.indexOf(userId) !== -1
    },
    toggleUser(user) {
      if (this.pushing || this.result) return
      if (this.isSelected(user.id)) {
        this.selectedIds = this.selectedIds.filter((id) => id !== user.id)
        return
      }
      if (this.selectedCount >= MAX_RECIPIENTS) return
      this.selectedIds = this.selectedIds.concat([user.id])
    },
    avatarOf(user) {
      return user.headimgurl || DEFAULT_AVATAR
    },
    onAvatarError(event) {
      if (event.target.src.indexOf(DEFAULT_AVATAR) === -1) {
        event.target.src = DEFAULT_AVATAR
      }
    },
    confirmPush() {
      if (this.pushing || this.selectedCount === 0 || this.result) return

      this.pushing = true
      this.error = ''
      Skylark.Libs.Ajax.post(`/admin/settings/wechat_push_templates/${this.template.id}/test_push.json`, {
        data: { user_ids: this.selectedIds },
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          this.result = data
        },
        error: (xhr) => {
          this.error = this.errorMessage(xhr, '测试推送失败')
        },
        complete: () => {
          this.pushing = false
        }
      })
    },
    errorMessage(xhr, fallback) {
      const errors = xhr.responseJSON && xhr.responseJSON.errors
      return errors && errors.length ? errors.join('；') : fallback
    },
    close() {
      this.$emit('close')
    }
  },
  template: `
    <modal
      title="测试推送"
      extend-class="wechat-test-push-modal"
      ref="modal"
      @afterClosed="close"
      @cancelClicked="close"
    >
      <div class="modal-body wechat-test-push-body">
        <div class="wechat-test-push-context">
          <p class="wechat-test-push-context-title">{{ contextTitle }}</p>
          <p class="wechat-test-push-context-hint">使用已保存配置和样例数据</p>
        </div>

        <template v-if="result">
          <div class="wechat-test-push-result">
            <p class="wechat-test-push-result-summary">
              成功 {{ result.sent.length }}，失败 {{ result.failed.length }}，跳过 {{ result.skipped.length }}
            </p>
            <ul v-if="result.sent.length" class="wechat-test-push-result-list">
              <li v-for="row in result.sent" :key="'sent-' + row.user_id">{{ row.name }}：已发送</li>
            </ul>
            <ul v-if="result.failed.length" class="wechat-test-push-result-list is-failed">
              <li v-for="row in result.failed" :key="'failed-' + row.user_id">{{ row.name }}：{{ row.error }}</li>
            </ul>
            <ul v-if="result.skipped.length" class="wechat-test-push-result-list is-skipped">
              <li v-for="row in result.skipped" :key="'skipped-' + row.user_id">{{ row.name }}：{{ row.error }}</li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="wechat-test-push-picker">
            <div class="wechat-test-push-search">
              <input
                class="push-template-control"
                placeholder="输入姓名或手机号"
                :value="keyword"
                :disabled="pushing"
                @input="keyword = $event.target.value; scheduleSearch()"
              >
            </div>

            <div v-if="users.length" class="wechat-test-push-user-list">
              <button
                v-for="user in users"
                :key="user.id"
                type="button"
                class="wechat-test-push-user"
                :class="{ 'is-selected': isSelected(user.id) }"
                :disabled="pushing || (!isSelected(user.id) && selectedCount >= maxRecipients)"
                @click="toggleUser(user)"
              >
                <span
                  class="wechat-test-push-check"
                  :class="{ 'is-checked': isSelected(user.id) }"
                  aria-hidden="true"
                ></span>
                <img
                  class="wechat-test-push-avatar"
                  :src="avatarOf(user)"
                  :alt="user.name"
                  @error="onAvatarError"
                >
                <span class="wechat-test-push-user-meta">
                  <span class="wechat-test-push-user-name">{{ user.name }}</span>
                  <span class="wechat-test-push-user-phone">{{ user.phone }}</span>
                </span>
              </button>
            </div>
            <div v-else class="wechat-test-push-empty">
              <p>{{ emptyHint }}</p>
            </div>
          </div>
        </template>

        <p v-if="error" class="push-template-error">{{ error }}</p>
      </div>
      <div class="modal-footer" slot="footer">
        <template v-if="result">
          <button class="outlined btn-default" @click="$refs.modal.close()">关闭</button>
        </template>
        <template v-else>
          <span class="wechat-test-push-count">已选 {{ selectedCount }}/{{ maxRecipients }}</span>
          <button class="outlined btn-default" :disabled="pushing" @click="$refs.modal.close()">取消</button>
          <button :disabled="pushing || selectedCount === 0" @click="confirmPush">{{ sendLabel }}</button>
        </template>
      </div>
    </modal>
  `
})
